type ActionKind = 'INCREASE' | 'DECREASE' | 'RESET';

export const ActionIncrease = (id: number): Action => ({ type: 'INCREASE', payload: { id } });
export const ActionDecrease = (id: number): Action => ({ type: 'DECREASE', payload: { id } });
export const ActionReset = (): Action => ({ type: 'RESET' });

export type Action = { type: ActionKind; payload?: { id: number } };
